import React from "react";
import Header from "../../../../ui-components/LandingPage/ContactUi/Header";

const Contact = () => {
  return (
    <>
      <div className="min-[2000px]:px-36">
        <Header />
      </div>
    </>
  );
};

export default Contact;